
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mypage/coupons",
      function () {
        return require("private-next-pages/mypage/coupons/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mypage/coupons"])
      });
    }
  